<mat-card>
    <mat-card-header>
        <mat-card-title>Workspace User</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="workspaceGroup" (ngSubmit)="addWorkspaceUser()">
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>User Email</mat-label>
                <input matInput type="email" [formControl]="workspaceGroup.controls.userEmailControl">
                <mat-error *ngIf="workspaceGroup.controls.userEmailControl.invalid">{{getErrorEmail()}}</mat-error>
            </mat-form-field>
            <mat-card-actions>
                <button mat-raised-button type="submit" *ngIf="!isProcessing" [disabled]="!workspaceGroup.valid" color="accent"><mat-icon>add_box</mat-icon>Add</button>
                <button mat-raised-button type="submit" *ngIf="isProcessing" disabled><mat-spinner></mat-spinner></button>
            </mat-card-actions>
            <mat-divider></mat-divider>
            <div class="loading-spinner" *ngIf="userList.length == 0">
                <mat-spinner></mat-spinner>
            </div>
            <table>
                <tr *ngFor="let user of userList">
                    <td>{{ user.displayName }} 
                        <br> 
                        <span class="user-email">{{ user.email }}</span> 
                    </td>
                    <td *ngIf="userForRemove == user.uid"><mat-spinner></mat-spinner></td>
                    <td *ngIf="userForRemove != user.uid"><mat-icon (click)="removeUser(user.uid)" matTooltip="Remove User">person_remove</mat-icon></td>
                </tr>
            </table>
        </form>
    </mat-card-content>
</mat-card>